import useSelectScenarioContext
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import {
  ExecuteSelectLoadingPage,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/ExecuteSelectLoadingPage';
import {
  FDBox, FDContentContainer, FDIcon, FDStack,
} from '@facet-wealth/design';
import {
  FadeInBox,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedCommon/ExecuteSelectLoadingPage/FadeInBox';
import ProposalCFPInsight from 'Organisms/ProposalCFPInsight';
import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import FacetPlanProposalScenarioSelectionReviewSection
  from 'Views/Page/Content/Templates/FacetPlanProposalScenarioSelectionIntroPageTemplate/FacetPlanProposalScenarioSelectionIntroPageReviewSection';
import FacetPlanProposalScenarioSelectionLearnMoreSection
  from 'Views/Page/Content/Templates/FacetPlanProposalScenarioSelectionIntroPageTemplate/FacetPlanProposalScenarioSelectionIntroPageLearnMoreSection';
import useUserContext from 'Context/UserContext';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import fr from 'facet-rest';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { metaOverrideSet }
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioSelectionRedefinedStepLayoutWithContentHeader/metaOverrideSet';
import Divider from 'Components/UI/Divider';

// Keep in mind when editing this component that this is used both on the intro page (both for the agent and client)
// and in the decision step within the scenario selection wizard.
export const ScenarioSelectionRedefinedPreviewScenarios = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  const { isAgent } = useUserContext();

  useBoneBackgroundColor();

  const { isSelecting } = useSelectScenarioContext();

  const reviewSection = resource.attr('sections')?.resources().findItem((section) => section.id() === 'scenario-selection-page-review-section');
  const learnMoreSection = resource.attr('sections')?.resources().findItem((section) => section.id() === 'scenario-selection-page-learn-more-section');

  const proposalExpirationRel = resource.withRelationship(
    fr.relationships.proposalExpiration.name,
    (rel) => rel,
    () => null,
  );

  const shouldAutoOpenCFPMessage = !resource.isTruthy('isProposalViewed') && !isAgent && !proposalExpirationRel;

  if (resource.isTruthy('shouldExecuteSelect') && isSelecting) {
    return <ExecuteSelectLoadingPage resource={resource} />;
  }

  return (
    <FDContentContainer maxWidth="lg">
      <FadeInBox>
        <FDStack direction={'column'} spacing={12} paddingY={8}>
          <FDStack direction="column" spacing={8} alignItems="center">
            <FDStack direction={'column'} spacing={6} width={'100%'}>
              <FDStack direction={'column'} alignItems={'center'} spacing={6}>
                <FDIcon icon={'fac'} size={'lg'} />
                <FDStack direction={'column'} alignItems={'center'} spacing={3}>
                  <MetaControl attrName={'title'} resource={resource} metaOverrideSet={metaOverrideSet} />
                  <FDStack direction={'column'} spacing={5} alignItems={'center'}>
                    <MetaControl attrName={'subtitle'} resource={resource} metaOverrideSet={metaOverrideSet} />
                    <ProposalCFPInsight
                      insightResource={resource}
                      shouldAutoDisplayDialog={shouldAutoOpenCFPMessage}
                    />
                  </FDStack>
                </FDStack>
              </FDStack>
              <FDBox paddingY={4}>
                {reviewSection ? <FacetPlanProposalScenarioSelectionReviewSection reviewSectionResource={reviewSection} /> : null}
              </FDBox>
            </FDStack>
            {learnMoreSection ? (<>
              <Divider />
              <FacetPlanProposalScenarioSelectionLearnMoreSection learnMoreSectionResource={learnMoreSection} />
            </>) : null}
          </FDStack>
          <MetaControl attrName={'disclaimerText'} resource={resource} metaOverrideSet={metaOverrideSet} />
        </FDStack>
      </FadeInBox>
    </FDContentContainer>
  );
};

ScenarioSelectionRedefinedPreviewScenarios.defaultProps = {
};

ScenarioSelectionRedefinedPreviewScenarios.propTypes = {
};
